// material-ui
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
// project import
import { drawerWidth } from 'config';
import { HeaderProps } from '.';

// ==============================|| HEADER - APP BAR STYLED ||============================== //

export type AppBarStyledProps = AppBarProps & HeaderProps;

const AppBarStyled = styled(AppBar, { shouldForwardProp: (prop) => prop !== 'open' })<AppBarStyledProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    })
}));

export default AppBarStyled;
